import { render, staticRenderFns } from "./Vescor.vue?vue&type=template&id=bb1e463c"
import script from "./Vescor.vue?vue&type=script&lang=js"
export * from "./Vescor.vue?vue&type=script&lang=js"
import style0 from "./Vescor.vue?vue&type=style&index=0&id=bb1e463c&prod&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports